import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  header: i18n.t('contract_versions.flows.update.steps.role_level_salary.header'),
  role: i18n.t('contract_versions.flows.update.steps.role_level_salary.role.label'),
  level: i18n.t('contract_versions.flows.update.steps.role_level_salary.level.label'),
  job_title: i18n.t('contract_versions.flows.update.steps.role_level_salary.job_title.label'),
  job_title_tooltip: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.job_title.tooltip'
  ),
  job_description: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.job_description.label'
  ),
  base_salary: i18n.t('contract_versions.flows.update.steps.role_level_salary.base_salary.label'),
  salary_frequency: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.salary_frequency.label'
  ),
  additional_compensations: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.additional_compensations.label'
  ),
  additional_compensations_hint: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.hints.additional_compensations'
  ),
  add_compensation: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.additional_compensations.add'
  ),
  payroll_policy: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.payroll_policies.payroll_policy'
  ),
  no_payroll_policy: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.payroll_policies.no_payroll_policy'
  ),
  payroll_policy_tooltip: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.payroll_policies.tooltip'
  ),
  payroll_policy_no_editable_tooltip: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.payroll_policies.no_editable_tooltip'
  ),
  a3innuva_job_position: i18n.t(
    'contract_versions.flows.update.steps.role_level_salary.a3innuva_job_position.label'
  ),
})
